function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import Select from 'components/Form/Select';
import FormGroup from 'components/Form/FormGroup';
import messages from '../../../../messages';
import styles from './Identifiers.pcss';
var _React_PureComponent;
class SelectStatusesOptionSection extends (_React_PureComponent = React.PureComponent) {
    get selectOptions() {
        return [
            'Mandatory',
            'Optional',
            'Hidden'
        ];
    }
    render() {
        const { statuses, sectionName, formValues, onSetFormValue, headerMessage } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: this.props.className,
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    className: "text--h5 mt-0 mb-6",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, headerMessage))
                }),
                statuses.map((select)=>{
                    const selectEntriesArray = get(formValues.values, sectionName);
                    const index = findIndex(selectEntriesArray, (selectEntry)=>selectEntry.name === select);
                    return /*#__PURE__*/ _jsx(FormGroup, {
                        id: `${sectionName}.[${index}].status`,
                        className: styles.selectStatuses__optionSection__formGroup,
                        isOneLiner: true,
                        labelMessage: messages.labels[select],
                        formValues: formValues,
                        children: /*#__PURE__*/ _jsx(Select, {
                            optionsFrom: this.selectOptions.map((option)=>({
                                    status: option,
                                    label: option
                                })),
                            valueKey: "status",
                            labelKey: "label",
                            onChange: onSetFormValue
                        })
                    }, `${sectionName}.[${select}].status`);
                })
            ]
        });
    }
}
_define_property(SelectStatusesOptionSection, "propTypes", {
    // Explicit props
    formValues: PropTypes.object.isRequired,
    sectionName: PropTypes.string.isRequired,
    statuses: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    headerMessage: PropTypes.object.isRequired,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    onSetFormValue: PropTypes.func.isRequired
});
_define_property(SelectStatusesOptionSection, "defaultProps", {
    className: ''
});
export default withStyles(styles)(SelectStatusesOptionSection);
